import { useCallback } from 'react'

import { FILTERS_STORAGE_KEY } from 'pages/reports/helpers/getInitialQueryString'

import { ReportFilterFormFields } from '../helpers/types'

/**
 * Hook to manage report filters state in sessionStorage and clean up URL params.
 */
const useReportFiltersState = () => {
  /**
   * Persists report filters in sessionStorage.
   */
  const setReportFilterState = useCallback((filters: ReportFilterFormFields) => {
    sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filters))
  }, [])

  /**
   * Resets report filters from sessionStorage and clears URL query parameters.
   */
  const resetReportFilterState = useCallback(() => {
    sessionStorage.removeItem(FILTERS_STORAGE_KEY)
  }, [])

  return {
    setReportFilterState,
    resetReportFilterState,
  }
}

export default useReportFiltersState
